'use strict';

var pageWidgetModule = angular.module('t2g.pageWidget', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = pageWidgetModule;

pageWidgetModule.controller('PageWidgetCtrl', require('./pageWidgetCtrl'));

pageWidgetModule.config(function($stateProvider) {
  $stateProvider.state('private.main.pageWidget', {
    url: '/page-widget',
    title: 'Page Widget',
    templateUrl: '/app/modules/pageWidget/pageWidgetView.html?v=4.5.6',
    controller: 'PageWidgetCtrl as PageWidgetCtrl',
    resolve: {
      office: function(OfficeDA) {
        return OfficeDA.get();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/pageWidget/pageWidgetModule.js